import { gsap } from 'gsap';
import { isTabletDown } from './isMobile';
import { SnapperInstance } from './snapper';

export class SceneNavigator {
    constructor() {
        this.scene = 1;
        this.sceneCount = SnapperInstance.snapPoints.length + (isTabletDown() ? 0 : 1);
    }

    init() {
        var header = document.querySelector('.header');
        var navigator = document.querySelector('#navigator');
        //document.createElement('div');
        //navigator.id = 'navigator';
        var options = '';
        for (var i = 1; i <= this.sceneCount; i++) {
            options += '<li' + (i === 1 ? ' class="active"' : '') + '>' + i + '</li>';
        }
        navigator.innerHTML = `
            <div class="marker">
                <div>1</div>
                <div class="divider">
                    <div></div>
                    <div></div>
                </div>
                <div>${this.sceneCount}</div>
            </div>
            <ul class="pages">
                ${options}
            </ul>
        `;
        if (isTabletDown()) {
            navigator.style.height = (document.body.clientHeight - header.clientHeight) + 'px';
        }
        header.append(navigator);

        var pages = navigator.querySelector('.pages');
        this._animation = gsap.timeline({
            paused: true,
            onReverseComplete: () => {
                pages.scrollTo(0, 0);
            }
        })
            .addLabel('start')
            .from('#navigator', { duration: .5, x: () => navigator.clientWidth }, 'start')
            .to('#navigator .marker > div:first-child', { duration: .3, autoAlpha: 0, x: -32 }, 'start')
            .to('#navigator .marker > div:last-child', { duration: .3, autoAlpha: 0, x: 32 }, 'start')
            .to('#navigator .divider > div:first-child', { duration: .5, rotate: 45 }, 'start')
            .to('#navigator .divider > div:last-child', { duration: .5, rotate: -45 }, 'start');

        pages.addEventListener('mouseenter', () => {
            clearTimeout(this._closeTimeout);
            SnapperInstance.lock();
        });
        pages.addEventListener('mouseleave', () => {
            if (!this._clicked) {
                SnapperInstance.unlock();
            }
            this._clicked = false;
        })
        

        this._options = pages.querySelectorAll('li');
        this._options.forEach(option => {
            option.addEventListener('click', function () {
                this._clicked = true;
                SnapperInstance.unlock();
                SnapperInstance.snapTo(parseInt(option.innerHTML) - 1);
                this._animation.reverse();
                this._open = false;
            }.bind(this));
        });

        var marker = navigator.querySelector('.marker');
        marker.addEventListener('click', function () {
            if (this._open) {
                this._animation.reverse();
            }
            else {
                this._animation.play();
            }
            this._open = !this._open;
        }.bind(this));
        navigator.addEventListener('mouseleave', function () {
            this._closeTimeout = setTimeout(function () {
                this._animation.reverse();
                this._open = false;
            }.bind(this), 500);
        }.bind(this));

        this._currentPage = marker.querySelector('div:first-child');

        SnapperInstance.addUpdateCallback(this._updatePage.bind(this));
    }

    _updatePage(index) {
        this._currentPage.innerHTML = index + 1;
        this._options.forEach((option, i) => {
            if (i === index) {
                option.classList.add('active');
            }
            else {
                option.classList.remove('active');
            }
        });
    }
}